// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"a856a479","32":"45e1a23d","92":"04648aca","364":"abc4681a","524":"0c4bd7af","584":"5ec5ee50","847":"2a296436","855":"d7fae4b5","915":"555100ef","982":"3b12a15c","991":"918f7cac"}[chunkId] + ".chunk.js";
};